export default {
  zh: {
    phoneNumPlaceholder: '手机号码',
    verificationPlaceholder: '验证码',
    setPassword: '设置密码',
    submit: '下一步',
    getVerificationCode: '获取验证码',
    sendAgain: '后重新发送',
    networkError: '网络错误，请稍后再试',
    sent: '已发送'
  },
  en: {
    phoneNumPlaceholder: 'Phone',
    verificationPlaceholder: 'Your Code',
    setPassword: 'Set Password',
    submit: 'Next',
    getVerificationCode: 'Send SMS',
    sendAgain: ' ',
    networkError: 'Network error, please try again later',
    sent: 'Sent'
  }
}



// WEBPACK FOOTER //
// ./src/components/resetPhonePwd/lang.js